import React from 'react';
import classes from './MiDoctaRedirect.module.css';
import midoctaLogo from '../../assets/images/midocta/midocta-logo.png';

const MIDOCTA_URL = 'https://midocta.cordoba.gob.ar';

const MiDoctaRedirect = () => {
  return (
    <div className={classes.page}>
      <div className={classes.card}>
        <img className={classes.logo} src={midoctaLogo} alt="MiDocta" />
        <h1 className={classes.title}>
          Descubrí MiDocta, la nueva plataforma digital de la Municipalidad de Córdoba
        </h1>
        <a className={classes.button} href={MIDOCTA_URL}>
          Ir a MiDocta
        </a>
      </div>
    </div>
  );
};

export default MiDoctaRedirect;
